import { useThemeGenerator } from '@office-start/theming-service';
import React, { useEffect } from 'react';

import { ClassNameHandler } from './class-name-handler';

// TODO: Fluent is investigating whether this functionality could be exposed in a less roundabout fashion
// React component that generates fluent css variables and passes the classname to which they were applied to a given callback prop
// classNameHandler should take the css variable scope class name and apply it to an element near app root
export const OfficeHomeFluentThemeProvider: React.FC<{ classNameHandler: ClassNameHandler}> = ({classNameHandler}) => {
    const themeProviderClass = useThemeGenerator();

    useEffect(() => {
        classNameHandler(themeProviderClass);
    }, [classNameHandler, themeProviderClass]);

    return (
        <></>
    );
};
